// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Categories__container___7_fLv{padding:48px 24px;background-color:#122182}.Categories__title___35xr6{color:#fff;font-weight:200;font-size:40px;line-height:48px;text-align:center}.Categories__categoryList___3H9zi{display:flex;flex-wrap:wrap;grid-gap:8px;gap:8px;justify-content:center;margin-top:40px}@media (min-width:720px){.Categories__categoryList___3H9zi{grid-gap:24px;gap:24px}}.Categories__category___1ekTO a{color:inherit;font-weight:400;font-size:20px;line-height:32px;display:block;padding:8px 20px;border-radius:24px;color:#fff;text-decoration:none;background-color:#1b31a4;transition-duration:.3s;transition-property:color,background-color}.Categories__category___1ekTO a:hover{background-color:#2441c5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "Categories__container___7_fLv",
	"title": "Categories__title___35xr6",
	"categoryList": "Categories__categoryList___3H9zi",
	"category": "Categories__category___1ekTO"
};
module.exports = ___CSS_LOADER_EXPORT___;
